import { Checkbox, ListSubheader } from "@mui/material";
import React from "react";

interface ReviewGroupSubheaderProps {
  name: string;
  benefitKey: string;
  parentChecked: boolean;
  parentIndeterminate: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ReviewGroupSubheader: React.FC<ReviewGroupSubheaderProps> = ({
  name,
  benefitKey,
  parentChecked,
  parentIndeterminate,
  onChange,
}) => (
  <ListSubheader
    data-testid={`review-group-subheader-${benefitKey}`}
    sx={{ fontSize: 12 }}
  >
    <Checkbox
      edge="start"
      tabIndex={-1}
      disableRipple
      checked={parentChecked}
      indeterminate={parentIndeterminate}
      onChange={onChange}
      slotProps={{
        input: {
          "aria-label": `benefit-checkbox-${benefitKey || name}`,
          id: `benefit-checkbox-${benefitKey || name}`,
        },
      }}
    />
    {name}
  </ListSubheader>
);

export default ReviewGroupSubheader;
